import { useState } from "react";
import ReportDropdown from "../../components/ReportDropdown1"
import { AnimatePresence, motion } from "framer-motion";

const countries = [
 "Angola",
"Kenya",
"Nigeria",
"South Africa",
"Uganda",
"Ghana",
"Ethiopia",
"Tanzania",
"Zimbabwe",
"Egypt",
"Morocco",
"Senegal",
"Zambia",
"Cameroon",
"Cote d'Ivoire",
"Algeria",
"Mozambique",
"Rwanda",
"Botswana",
"Mali",

];

const dropdownItems = {
  COUNTRY: [
   "Angola",
"Kenya",
"Nigeria",
"South Africa",
"Uganda",
"Ghana",
"Ethiopia",
"Tanzania",
"Zimbabwe",
"Egypt",
"Morocco",
"Senegal",
"Zambia",
"Cameroon",
"Cote d'Ivoire",
"Algeria",
"Mozambique",
"Rwanda",
"Botswana",
"Mali",

  ],
  REGION: [
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",


    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
  ],
  PROJECT: [
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
  ],

  CROP: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  LIVESTOCK: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
  DATA : [
    "PRODUCTION", "Revenue", "Inventory"],
};

const dropdownIcons = {
  COUNTRY:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
    REGION:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    CROP:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
       DATA:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    PROJECT:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
    LIVESTOCK:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
};

const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  const icon = dropdownIcons[type];

  return (
<div className="flex flex-col w-full relative ">
  {/* Label */}
  <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
    {label}
  </label>

  {/* Button + Icon Container */}
  <div className="flex relative z-20 w-fit">
    {/* Dropdown Button */}
    <button
      onClick={() => setIsOpen((prev) => !prev)}
      className="xl:w-[160px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[47px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-1 rounded-l-[5px]"
    >
      <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
    </button>

    {/* Icon Box */}
    <div
      className="w-[20px] h-[15px] md:h-[47px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-tr-[5px]   rounded-br-[5px]  -ml-2 z-30 cursor-pointer"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
        alt="expand"
        className="w-3 h-3 md:w-5 md:h-5"
      />
    </div>
  </div>

  {/* Dropdown List */}
  {/* Dropdown List */}
  <AnimatePresence>
  {isOpen && (
    <motion.ul
  initial={{ opacity: 0, height: 0 }}
  animate={{ opacity: 1, height: "auto" }}
  exit={{ opacity: 0, height: 0 }}
  className="mt-1 w-full md:w-[180px] bg-white/90  overflow-hidden"
>

      {items.map((item, index) => (
        <li
          key={index}
          onClick={() => {
            setSelected(item);
            setIsOpen(false);
          }}
          className="md:p-1 p-1  md:mt-1 md:text-[14px] font-bold text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
        >
          <span className="text-black">{item}</span>
        </li>
      ))}
    </motion.ul>
  )}
</AnimatePresence>


  {/* Hint Text */}
  <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
    Select {label}
  </p>

</div>


  
  );
};
// Dummy province data for each section
const sectionData = [
  {
    title: "SOUTH AFRICA",
    label: "PROVINCES",
    values: [
      "GAUTENG", "NORTH WEST", "FREE STATE", "WESTERN CAPE", "NORTHERN CAPE",
      "EASTERN CAPE", "KWAZULU NATAL", "LIMPOPO", "MPUMALANGA"
    ],
    gridCols: 9,
  },
  {
    title: "NAMIBIA",
    label: "REGIONS",
    values: [
      "Erongo Region",
      "Hardap Region",
      "ǁKaras Region",
      "Kavango East Region",
      "Kavango West Region",
      "Khomas Region",
      "Kunene Region",
      "Ohangwena Region",
      "Omaheke Region",
      "Omusati Region",
      "Oshana Region",
      "Oshikoto Region",
      "Otjozondjupa Region",
      "Zambezi Region",
    ],
    gridCols: 7,
  },
  {
    title: "BURUNDI",
    label: "PROVINCES",
    values: [
      "Cankuzo Province",
      "Gitega Province",
      "Rutana Province",
      "Ruyigi Province",
      "Karuzi Province",
      "Kayanza Province",
      "Kirundo Province",
      "Muyinga Province",
      "Ngozi Province",
      "Bururi Province",
      "Makamba Province",
      "Rumonge Province",
      "Bujumbura Mairie",
      "Bujumbura Rural",
      "Cibitoke Province",
      "Muramvya Province",
      "Mwaro Province",
    ],
    gridCols: 7,
  },
  {
    title: "MALAWI",
    label: "REGIONS",
    values: [
      "Northern Region",
      "Central Region",
      "Southern Region",
      "--", "--", "--", "--", "--", "--"
    ],
    gridCols: 9,
  },
  {
    title: " ZAMBIA",
    label: "PROVINCES",
    values: [
      "Central Province",
      "Copperbelt Province",
      "Eastern Province",
      "Luapula Province",
      "Lusaka Province",
      "Muchinga Province",
      "Northern Province",
      "North-Western Province",
      "Southern Province",
      "Western Province",
      "-", "-", "-", "-", "-", "-", "-", "-",
    ],
    gridCols: 9,
  },
  {
    title: "KENYA",
    label: "COUNTIES",
    values: [
      "Mombasa County",
      "Kwale County",
      "Kilifi County",
      "Tana River County",
      "Lamu County",
      "Taita Taveta County",
      "Garissa County",
      "Wajir County",
      "Mandera County",
      "Marsabit County",
      "Isiolo County",
      "Meru County",
      "Tharaka Nithi County",
      "Embu County",
      "Kitui County",
      "Machakos County",
      "Makueni County",
      "Nyandarua County",
      "Nyeri County",
      "Kirinyaga County",
      "Murang’a County",
      "Kiambu County",
      "Turkana County",
      "Samburu County",
      "Trans Nzoia County",
      "Uasin Gishu County",
      "Elgeyo Marakwet County",
      "Nandi County",
      "Baringo County",
      "Laikipia County",
      "Nakuru County",
      "Narok County",
      "Kajiado County",
      "Kericho County",
      "Bomet County",
      "Kakamega County",
      "Vihiga County",
      "Bungoma County",
      "Busia County",
      "Siaya County",
      "Kisumu County",
      "Homa Bay County",
      "Migori County",
      "Kisii County",
      "Nyamira County",
      "Nairobi County",
      "-", "-", "-", "-", "-", "-", "-",
    ],
    gridCols: 9,
  }
];

const MoreReportPage3 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(countries[0]);

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-5 pt-3 pb-6">
        <div className="mb-2">
          <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
            COUNTRY
          </label>
          <div className="flex flex-col w-full relative">
            {/* Button + Icon */}
            <div className="flex relative z-20 w-fit">
              <button
                onClick={() => setIsOpen((prev) => !prev)}
                className="xl:w-[180px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-3 rounded-l-[10px]"
              >
                <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">
                  {selected}
                </span>
              </button>

              <div
                className="w-[20px] h-[15px] md:h-[40px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-[10px] -ml-2 z-30 cursor-pointer"
                onClick={() => setIsOpen((prev) => !prev)}
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                  alt="expand"
                  className="w-3 h-3 md:w-5 md:h-5"
                />
              </div>
            </div>
            <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
              Select country
            </p>
            {/* Dropdown List */}
            <AnimatePresence>
  {isOpen && (
    <motion.ul
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="mt-1 md:w-[200px] w-[100px] bg-white/90"
    >
      {countries.map((country, i) => (
        <li
          key={i}
          onClick={() => {
            setSelected(country);
            setIsOpen(false);
          }}
          className="p-1 font-bold md:mt-1 md:text-[14px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer"
        >
          {country}
        </li>
      ))}
    </motion.ul>
  )}
</AnimatePresence>

           
          </div>
        </div>
        <div className="md:mt-52 mt-20">
          {sectionData.map((section, index) => (
            <div key={index} className="">
              {/* Dropdown */}

              {/* Header and Run Report Button */}
              <div className="flex justify-between items-center md:mb-4 md:mt-20 mt-10">
                <h2 className="md:text-[32px] text-[14px] font-bold md:mb-2">
                  <span className="text-[#979797]">Outlook | </span>
                  {section.title}
                </h2>
                <div className="flex items-center flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
                  <p className="md:text-[16px] text-[5px] bg-[#2E453D] text-white px-2 md:w-[220px] md:py-[9px] md:px-4 py-[3px] md:rounded-tl-[10px] rounded-tl-md font-bold md:rounded-bl-[10px] rounded-bl-md whitespace-nowrap">
                    RUN REPORT
                  </p>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                    alt="Expand"
                    className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] md:flex hidden object-contain md:rounded-tr-md rounded-tr-md font-bold md:rounded-br-md bg-[#FFBD26] px-2 md:py-2"
                  />
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                    alt="Expand"
                    className="w-[20px] h-[13px] md:hidden py-[1px] flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-[10px] rounded-tr-md font-bold md:rounded-br-[10px] rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
                  />
                </div>
              </div>

              {/* Province/Region/County Grid */}
              <div className="flex md:flex-row gap-1 md:gap-16">
                {/* Label */}
                <div className="w-[90px] md:w-[200px]">
                  <p className="text-[#FFBD26] font-bold text-[10px] md:text-[20px]">
                    {section.label}
                  </p>
                </div>

                {/* Grid */}
                <div
                  className={`grid grid-cols-3 md:grid-cols-9 gap-2 flex-1`}
                >
                  {section.values.map((value, i) => (
                    <div
                      key={i}
                      className="flex items-center justify-center text-[6px] md:text-[10px] md:w-[98px] md:h-[44px] border-b-[3px] border-[#979797]/90 rounded-[5px] text-black font-extrabold py-[2px] text-center"
                    >
                      {value}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="md:h-40 h-10">

        </div>
        <div className="flex md:gap-2 gap-[1px]   ">
    

    {Object.keys(dropdownItems).map((type) => {
      const customLabels = {
        Crop: "Crop Report",
        Livestock: "Livestock Report",
        Type: "Type of Report",
      };

      const displayLabel = customLabels[type] || type;

      return (
        <div key={type} className="w-full sm:w-auto">
          <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
        </div>
      );
    })}
  </div>
  <div className="md:h-72 h-10">

</div>
  <ReportDropdown/>
      </div>
    </div>
  );
};

export default MoreReportPage3;